<template>
  <div class="multiple-select border rounded border-color-light-gray">
    <div class="bg-light-gray p-2">
      <v-select
        v-model="selectedOption"
        class="w-100"
        :class="
          onDemand && filteredOptions.length == 0 ? 'picker-hide-options' : ''
        "
        :placeholder="placeholder"
        :options="filteredOptions"
        @search="search"
      >
        <template #option="{ data }">
          <slot name="option" v-bind:data="data"></slot>
        </template>
        <template #selected-option="{ data }">
          <slot name="selected-option" v-bind:data="data"></slot>
        </template>
        <template #spinner>
          <div></div>
        </template>
        <template #list-footer>
          <li v-if="loading" class="vs__spinner"></li>
        </template>
        <template #no-options>
          <li v-if="!loading">Sorry, no matching options</li>
          <li v-else>&nbsp;</li>
        </template>
      </v-select>
    </div>
    <div
      class="select-list-container"
      :style="{ maxHeight: this.listMaxHeight || `600px` }"
    >
      <div v-if="value.length > 0">
        <div
          class="d-flex align-items-center justify-content-end"
          style="margin-bottom: -9px; margin-top: 6px"
        >
          <div v-if="!hideUnits" class="d-flex align-items-center">
            <span style="width: 84px; font-size: 12px" class="ml-2">
              Cost/Unit ($)
            </span>
            <span style="width: 98px; font-size: 12px" class="ml-2">
              Number of units
            </span>
          </div>
        </div>
        <b-list-group class="mt-1 p-1 forms-list">
          <div>
            <b-list-group-item
              class="filter-value border pl-2 pr-2 pt-1 pb-1 mr-2 ml-1 mt-2"
              v-for="(valueItem, valueItemIndex) in value"
              :key="valueItemIndex"
            >
              <span v-show="!hideMods">{{ valueItem.label }}</span>

              <div v-for="(item, index) in valueItem.billingCodes" :key="index">
                <slot name="selected-option" v-bind:data="valueItem.data">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <span v-show="hideMods">{{ valueItem.label }}</span>
                    <div class="d-flex align-items-center">
                      <div
                        v-if="!hideMods || !hideUnits"
                        class="d-flex flex-column align-items-start"
                      >
                        <span>Mod 1</span>
                        <b-form-input
                          :s:tyle="`width: ${modsWidth}`"
                          v-model="item.mod1"
                          type="text"
                          size="sm"
                          min="0"
                        ></b-form-input>
                      </div>
                      <div
                        v-if="!hideMods || !hideUnits"
                        class="d-flex flex-column align-items-start ml-3"
                      >
                        <span>Mod 2</span>
                        <b-form-input
                          :style="`width: ${modsWidth}`"
                          v-model="item.mod2"
                          type="text"
                          size="sm"
                          min="0"
                        ></b-form-input>
                      </div>
                      <div
                        v-if="!hideMods || !hideUnits"
                        class="d-flex flex-column align-items-start ml-3"
                      >
                        <span>Mod 3</span>
                        <b-form-input
                          :style="`width: ${modsWidth}`"
                          v-model="item.mod3"
                          type="text"
                          size="sm"
                          min="0"
                        ></b-form-input>
                      </div>
                      <div
                        v-if="!hideMods || !hideUnits"
                        class="d-flex flex-column align-items-start ml-3"
                      >
                        <span>Mod 4</span>
                        <b-form-input
                          :style="`width: ${modsWidth}`"
                          v-model="item.mod4"
                          type="text"
                          size="sm"
                          min="0"
                        ></b-form-input>
                      </div>

                      <div
                        v-if="!hideUnits"
                        class="d-flex flex-column align-items-start"
                      >
                        <span style="visibility: hidden" v-show="!hideMods"
                          >Cost</span
                        >
                        <b-form-input
                          style="width: 80px"
                          class="ml-2"
                          v-model="item.costPerUnit"
                          type="number"
                          size="sm"
                          min="0"
                        ></b-form-input>
                      </div>

                      <div
                        v-if="!hideUnits"
                        class="d-flex flex-column align-items-start"
                      >
                        <span style="visibility: hidden" v-show="!hideMods"
                          >Units</span
                        >
                        <b-form-input
                          style="width: 80px"
                          class="ml-2"
                          v-model="item.numberOfUnits"
                          type="number"
                          size="sm"
                          min="0"
                          @focusout="fixNumberOfUnitsInput(item)"
                        ></b-form-input>
                      </div>
                    </div>
                  </div>
                </slot>
              </div>

              <img
                class="filter-value-delete"
                :src="require('../../assets/icons/close-circle.png')"
                @click="removeSelected(valueItemIndex)"
              />
            </b-list-group-item>
          </div>
        </b-list-group>
        <div v-if="!hideUnits" class="d-flex justify-content-end">
          <span style="font-size: 12px; margin-right: 12px"
            >Total: {{ toCurrencyValue(totalValue) }}</span
          >
        </div>
      </div>
      <div v-else class="text-center color-custom-dark-grey m-1">
        No items selected.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MultipleSelectUnitRate",
  props: {
    value: {
      type: Array,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: ""
    },
    search: {
      type: Function,
      default: () => {}
    },
    loading: {
      type: Boolean
    },
    sortFn: {
      type: Function,
      default: (a, b) => a.label.localeCompare(b.label)
    },
    onDemand: {
      type: Boolean,
      default: false
    },
    hideUnits: {
      type: Boolean,
      default: false
    },
    hideMods: {
      type: Boolean,
      default: false
    },
    modsWidth: {
      type: Number,
      default: 80
    },
    noCached: {
      type: Boolean,
      default: false
    },
    listMaxHeight: {
      type: String,
      default: "600px"
    }
  },
  data() {
    return {
      cachedOptions: []
    };
  },
  mounted() {
    this.addOptionsToCache(this.options);
  },
  methods: {
    fixNumberOfUnitsInput(item) {
      if(item.numberOfUnits === "" || item.numberOfUnits < 0)
        item.numberOfUnits = 0;
    },
    removeSelected(itemIndex) {
      const value = [...this.value];
      value.splice(itemIndex, 1);
      this.emit(value);
    },
    emit(value) {
      this.$emit("input", [...value]);
    },
    addOptionsToCache(options) {
      if (!options || !options.length) {
        return;
      }

      this.cachedOptions = options
        .filter(
          item => !this.cachedOptions.some(cached => cached.value == item.value)
        )
        .concat(this.cachedOptions)
        .sort(this.sortFn);
    }
  },
  computed: {
    selectedOption: {
      get() {
        return null;
      },
      set(newValue) {
        if (newValue) {
          const value = [...this.value];
          value.push(newValue);
          this.emit(value);
        }
      }
    },
    filteredOptions() {
      return this.cachedOptions.filter(
        opt =>
          !this.value.some(o => opt.value == o.value && opt.label == o.label)
      );
    },
    totalValue() {
      let total = 0;

      if (this.value && this.value.length) {
        this.value.forEach(service => {
          if (service.billingCodes && service.billingCodes.length) {
            service.billingCodes.forEach(billingCode => {
              const numberOfUnits = billingCode.numberOfUnits;
              const costPerUnit = billingCode.costPerUnit;
              const subtotal =
                numberOfUnits && costPerUnit ? numberOfUnits * costPerUnit : 0;
              total += subtotal;
            });
          }
        });
      }

      return total;
    }
  },
  watch: {
    options(newValue) {
      if (!this.noCached) {
        this.addOptionsToCache(newValue);
      } else {
        this.cachedOptions = newValue;
      }
    },
    value: {
      handler: function(newValue) {
        newValue.forEach(value => {
          if (
            !Object.prototype.hasOwnProperty.call(value, "billingCodes") ||
            value.billingCodes.length === 0
          ) {
            this.$set(value, "billingCodes", [
              {
                mod1: value.mod1 || "",
                mod2: value.mod2 || "",
                mod3: value.mod3 || "",
                mod4: value.mod4 || "",
                serviceId: value.value,
                numberOfUnits: value.numberOfUnits,
                costPerUnit: value.costPerUnit
              }
            ]);
          }
        });
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.select-list-container {
  overflow-y: auto;
  overflow-x: hidden;
}
.filter-value {
  position: relative;
  min-width: 100px;
  color: #a6a6a6;
  font-size: 14px;
}
.filter-value-delete {
  position: absolute;
  top: -8px;
  right: -8px;
}
.filter-value-delete:hover {
  cursor: pointer;
}

.multiple-select >>> .vs--single .vs__selected {
  z-index: 10;
}
.multiple-select >>> .vs--single.vs--open .vs__selected {
  position: initial;
}
.multiple-select >>> .vs__spinner {
  opacity: 1;
  border-left-color: rgba(88, 151, 251, 0.71);
  padding: 0.5em;
  text-align: center;
  margin: 0.5em auto;
}
.multiple-select >>> .vs__selected-options input {
  position: absolute;
  width: 100%;
  height: 100%;
}
.multiple-select >>> .vs__dropdown-menu {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.picker-hide-options .vs__dropdown-menu {
  display: flex;
}
.picker-hide-options.vs--open .vs__dropdown-toggle {
  border-bottom-width: 2px;
}
.multiple-select >>> .vs__dropdown-menu li {
  white-space: normal;
}
</style>
